import React, { useState, useEffect } from 'react'
import Header from '../component/header';
import "../assets/css/documents.css";
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import configModule from '../../config.js';
import { Toaster, toast } from "react-hot-toast";

function Documents() {
  const [usersData, setUsersData] = useState(null);
  const [docsDetails, setDocsDetails] = useState([]);
  const config = configModule.config();
  const [search, setSearch] = useState("");
  const [downloading, setDownloading] = useState(null);

  const getDashboardData = async () => {

    try {
      const response = await axios.get(
        `${config.apiBaseUrl}/get-documents/${usersData?.id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data?.data;
      setDocsDetails(data);


    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";

      toast.error(message);
    }
  };

  useEffect(() => {
    if (usersData?.id) {
      getDashboardData();
    }
  }, [usersData]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const decoded = jwtDecode(token);
      setUsersData(decoded);
    }
  }, []);

  const downloadDocument = async (id, index) => {
    try {
      setDownloading(index);

      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${config.apiBaseUrl}/download-document/${id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data])
      );

      const link = document.createElement("a");

      link.href = url;

      // Get filename from backend response if available
      const contentDisposition =
        response.headers["content-disposition"];

      let fileName = "document.pdf";

      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename="?([^"]+)"?/
        );

        if (match?.[1]) {
          fileName = match[1];
        }
      }

      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();

      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Download error:", error);

      toast.error(
        error.response?.data?.message ||
        "Unable to download document"
      );
    } finally {
      setDownloading(null);
    }
  };

  const viewDocument = async (id, index) => {
    try {
      setDownloading(index);

      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${config.apiBaseUrl}/download-document/${id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const file = new Blob([response.data], {
        type: response.headers["content-type"] || "application/pdf",
      });

      const url = window.URL.createObjectURL(file);

      window.open(url, "_blank");

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 10000);

    } catch (error) {
      console.error("View document error:", error);

      toast.error(
        error.response?.data?.message ||
        "Unable to view document"
      );
    } finally {
      setDownloading(null);
    }
  };

  const filteredDocuments = docsDetails?.filter((item) => {
    const searchText = search.toLowerCase().trim();

    if (!searchText) return true;

    return (
      item?.doc_name?.toLowerCase().includes(searchText) ||
      item?.doc_type?.toLowerCase().includes(searchText) ||
      item?.uploaded_at?.toLowerCase().includes(searchText)
    );
  });

  const formatPaymentDate = (date) => {
    if (!date) return "";

    const d = new Date(date);

    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();

    let hours = d.getUTCHours();
    const minutes = String(d.getUTCMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours || 12;

    hours = String(hours).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
};

  return (
    <div className='dashboardmain-st'>
      <Header pageName="Documents" />
      <div className="body-dashboard">
        <div className="page-header">
          <div className="page-eyebrow">All Files</div>
          <div className="page-title">Documents</div>
          <div className="page-subtitle">All documents across your investments</div>
        </div>

        <div className="search-bar">
          <input
            className="search-input"
            placeholder="Search documents..."
            style={{ maxWidth: "320px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="chart-card" style={{ background: "white" }}>
          {filteredDocuments?.length > 0 ? (
            filteredDocuments.map((item, index) => (
              <div className="doc-row" key={index}>
                <div className="doc-icon"><svg viewBox="0 0 24 24" strokeWidth="1.8" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></div>
                <div className="doc-info">
                  <div className="doc-name">{item?.doc_name}</div>
                  <div className="doc-meta">PDF · {item?.uploaded_at ? formatPaymentDate(item?.uploaded_at) : ''}</div>
                </div>
                <span className="doc-type-badge">{item?.doc_type}</span>
                <button
                  className="doc-dl"
                  disabled={downloading === index}
                  onClick={() => viewDocument(item?.id, index)}
                  title="View document"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                </button>
                <button
                  className="doc-dl"
                  disabled={downloading === index}
                  onClick={() => downloadDocument(item?.id, index)}
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </button>
              </div>
            ))
          ) : (
            <div className="text-center p-4" style={{ background: "#f7f2e8" }}>
              {search ? "No documents found...!" : "No documents available...!"}
            </div>
          )}
        </div>
      </div>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#0a1628",
            color: "#fff",
            borderRadius: "10px",
            padding: "14px 18px",
          },
          success: {
            iconTheme: {
              primary: "#22c55e",
              secondary: "#fff",
            },
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#fff",
            },
          },
        }}
      />
    </div>
  )
}

export default Documents;
